import { render, staticRenderFns } from "./FreeGptMobile.vue?vue&type=template&id=0edd0f5a&scoped=true"
import script from "./FreeGptMobile.vue?vue&type=script&lang=js"
export * from "./FreeGptMobile.vue?vue&type=script&lang=js"
import style0 from "./FreeGptMobile.vue?vue&type=style&index=0&id=0edd0f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd0f5a",
  null
  
)

export default component.exports